import React from "react";
import { Image, Pressable, View } from "react-native";
import Text from "@components/CustomText";
import { kycStyles as s } from "./styles";

// Onboarding-styled upload tile. Empty → dark tap-to-upload tile with an up
// arrow + CTA. Filled → the captured image fills the tile, with a green check
// badge when locked or a delete affordance while editable. Prefers the local
// capture URI (previewUri) for immediate display, falling back to the stored
// URL (source) on revisit (PROCESSING/VERIFIED).
const Photo = (props) => {
  const {
    source = "",
    previewUri = "",
    imageHeaders = null,
    disabled = false,
    onUpload = () => {},
    onDelete = () => {},
    ctaText = "",
    style,
  } = props;

  const uri = previewUri || source;
  // Remote KYC images are private (get-private-file) and need the DB's auth
  // token; a local file:// preview needs none.
  const imageSource =
    uri.startsWith("http") && imageHeaders
      ? { uri, headers: imageHeaders }
      : { uri };

  if (!uri) {
    return (
      <Pressable
        disabled={disabled}
        onPress={onUpload}
        android_ripple={{ color: "rgba(255,255,255,0.15)", borderless: false }}
        style={[s.tile, style]}
      >
        <Text style={s.tileIcon}>↑</Text>
        <Text style={s.tileText}>{ctaText}</Text>
      </Pressable>
    );
  }

  return (
    <View style={[s.tile, s.tileFilled, style]}>
      <Image source={imageSource} style={s.tileImage} resizeMode="cover" />
      {disabled ? (
        <View style={s.tileBadge}>
          <Text style={s.tileBadgeText}>✓</Text>
        </View>
      ) : (
        <Pressable
          onPress={onDelete}
          style={s.tileDelete}
          android_ripple={{ color: "rgba(255,255,255,0.2)", borderless: true }}
        >
          <Text style={s.tileDeleteText}>✕</Text>
        </Pressable>
      )}
    </View>
  );
};

export default Photo;
